<form [ngStyle]="{ 'margin-top': isLabelFixed() ? '30px' : '0' }">

  <div class="select-container">
    <button
      type="button"
      [id]="uniqueId()"
      class="custom-select-trigger"
      [class.has-value]="hasValue()"
      [class.has-placeholder]="!!placeholder()"
      [class.is-open]="isOpen()"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-labelledby]="uniqueId() + '-label ' + uniqueId()"
      [attr.aria-describedby]="isInvalid() ? errorId() : null"
      [attr.aria-invalid]="isInvalid() ? 'true' : null"
      [attr.aria-required]="required() ? 'true' : null"
      [disabled]="isDisabled()"
      (click)="toggle()"
      (keydown)="onKeyDown($event)"
    >
      @if (selectedLabel()) {
        <span class="selected-text">{{ selectedLabel() }}</span>
      } @else {
        <span class="selected-text selected-text--placeholder">{{ placeholder() }}</span>
      }
      <app-svg-icon class="arrow-icon" [src]="'icon/dropdown-arrow.svg'"></app-svg-icon>
    </button>

    <label
      [class.caption]="!isLabelFixed()"
      [class.fixed-label]="isLabelFixed()"
      [id]="uniqueId() + '-label'"
      [for]="uniqueId()"
    >
      {{ label() }}
      @if (required()) {
        <span class="required-asterisk" aria-hidden="true"> *</span>
      }
    </label>

    @if (isOpen()) {
      <ul
        #optionsList
        class="options-list"
        role="listbox"
        [id]="uniqueId() + '-listbox'"
        [attr.aria-label]="label()"
        [attr.aria-activedescendant]="activeIndex() >= 0 ? uniqueId() + '-opt-' + activeIndex() : null"
      >
        @for (option of normalizedOptions(); track option.value; let i = $index) {
          <li
            #optionItem
            role="option"
            [id]="uniqueId() + '-opt-' + i"
            class="option-item"
            [class.active]="i === activeIndex()"
            [class.selected]="String(option.value) === String(control().value)"
            [attr.aria-selected]="String(option.value) === String(control().value)"
            (click)="select(option)"
            (mouseenter)="activeIndex.set(i)"
          >
            {{ option.label }}
          </li>
        }
      </ul>
    }
  </div>

  @if (isInvalid()) {
    <span
      [id]="errorId()"
      class="error-message"
      role="alert"
      aria-live="polite"
    >
      Campo obbligatorio
    </span>
  }

</form>
